/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Button, Checkbox, Divider, Form, Input } from 'antd';
import { useMagicCode, useRemember } from 'hooks';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from 'images/N_Logo.svg';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { LoginCertTooltipContent } from 'pages/Login/style';

export interface LoginProps {
  loading: boolean;
  onLogin: (v: any) => void;
}

const Login = ({ loading, onLogin }: LoginProps) => {
  const [form] = Form.useForm();
  const [code] = useMagicCode();
  const [autoLogin, setAutoLogin] = useRemember();
  const formItemLayout = {
    labelCol: {
      span: 24
      // xs: { span: 24 },
      // sm: { span: 6 }
    },
    wrapperCol: {
      span: 24
      // xs: { span: 24 },
      // sm: { span: 14 }
    }
  };

  const [hover, setHover] = useState<boolean>(false);

  useEffect(() => {
    form?.setFieldValue('remember', autoLogin);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  const changeMode = () => {
    const username = form.getFieldValue('username');
    if (username === 'gitmerge') {
      alert('지원하지 않는 기능입니다');
    }
  };

  return (
    <>
      <div className="login-logo">
        <img src={logo} alt="login logo" onClick={changeMode} />
        <b className="mode">{code ? `# MODE: ${code}` : ''}</b>
      </div>
      <Form form={form} autoComplete="off" onFinish={onLogin} {...formItemLayout}>
        <Form.Item id="username" className="username" name="username">
          <Input placeholder="아이디를 입력해주세요" />
        </Form.Item>
        <Form.Item id="password" className="password" name="password">
          <Input.Password placeholder="비밀번호를 입력해주세요" />
        </Form.Item>
        <Form.Item className="remember-wrapper" name="remember" valuePropName="checked">
          <Checkbox className="remember" onChange={() => setAutoLogin(!autoLogin)}>
            자동 로그인
          </Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            로그인
          </Button>
        </Form.Item>
        <Form.Item className="go-to">
          <Link to="/forgotSignId">아이디 찾기</Link>
          <Divider type="vertical" />
          <Link to="/forgotPassword">비밀번호 재설정</Link>
          <Divider type="vertical" />
          <Link to="/agreeSignUp">회원가입</Link>
        </Form.Item>
        <Form.Item className="isms">
          <ExclamationCircleOutlined
            onMouseEnter={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
            style={{ marginRight: '3px' }}
          />
          <span
            onMouseEnter={() => {
              setHover(true);
            }}
            onMouseLeave={() => {
              setHover(false);
            }}
          >
            정보보호관리체계인증(ISMS)
          </span>
          {hover && (
            <LoginCertTooltipContent>
              <p style={{ marginBottom: 0 }}>
                <strong>인증범위:</strong> 기업 복지 서비스 플랫폼(식권대장)(정보통신망법 제47조의7에 따른 인증의 특례)
              </p>
              <p style={{ marginBottom: 0 }}>
                <strong>유효기간:</strong> 2026.03.18 ~ 2029.03.17
              </p>
            </LoginCertTooltipContent>
          )}
        </Form.Item>
        <Form.Item className="policy-links">
          <a href="https://sikdae.com/privacy" target="_blank" rel="noopener noreferrer">
            <strong>개인정보 처리방침</strong>
          </a>
          <Divider type="vertical" />
          <a href="https://sikdae.com/term" target="_blank" rel="noopener noreferrer">
            이용약관
          </a>
        </Form.Item>
      </Form>
    </>
  );
};

export default Login;
